module.exports = __webpack_public_path__ + "static/media/MNV-srikanta-iim-l-singhania-award-nomination.9cda5d0f.pdf";